import { render, staticRenderFns } from "./ExamIntermediateComponent.vue?vue&type=template&id=0bedc4a2&scoped=true&"
import script from "./ExamIntermediateComponent.vue?vue&type=script&lang=js&"
export * from "./ExamIntermediateComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExamIntermediateComponent.vue?vue&type=style&index=0&id=0bedc4a2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bedc4a2",
  null
  
)

export default component.exports